const state={
	resumeid:0,
	editting:false,
}

// actions
const actions = {
  
}

// mutations
const mutations = {


//setEditting (state, { items }) {
//  state.editting = items
//}

}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/resume.js